
// import React from "react";
// import { Link } from "react-router-dom";
// import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
// import styles from "./BlogNavigator.module.css";

// export default function BlogNavigator({ category, blogs, currentBlogId }) {
//   const currentIndex = blogs.findIndex((b) => b.id === currentBlogId);
//   const prevBlog = currentIndex > 0 ? blogs[currentIndex - 1] : null;
//   const nextBlog =
//     currentIndex < blogs.length - 1 ? blogs[currentIndex + 1] : null;

//   return (
//     <div className={styles.blogNavigator}>
//       {/* Previous Button */}
//       {prevBlog ? (
//         <Link
//           to={`/blog/${category}/${prevBlog.id}`}
//           className={`${styles.navBtn} ${styles.prev}`}
//         >
//           <FaArrowLeft className={styles.icon} />
//           <span>{prevBlog.title}</span>
//         </Link>
//       ) : (
//         <span className={`${styles.navBtn} ${styles.prev} ${styles.disabled}`}>
//           <FaArrowLeft className={styles.icon} />
//           <span>Previous</span>
//         </span>
//       )}

//       {/* Next Button */}
//       {nextBlog ? (
//         <Link
//           to={`/blog/${category}/${nextBlog.id}`}
//           className={`${styles.navBtn} ${styles.next}`}
//         >
//           <span>{nextBlog.title}</span>
//           <FaArrowRight className={styles.icon} />
//         </Link>
//       ) : (
//         <span className={`${styles.navBtn} ${styles.next} ${styles.disabled}`}>
//           <span>Next</span>
//           <FaArrowRight className={styles.icon} />
//         </span>
//       )}
//     </div>
//   );
// }




import React from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import styles from "./BlogNavigator.module.css";

export default function BlogNavigator({ category, blogs, currentBlogId }) {
  const currentIndex = blogs.findIndex((b) => b.id === currentBlogId);
  const prevBlog = currentIndex > 0 ? blogs[currentIndex - 1] : null;
  const nextBlog =
    currentIndex < blogs.length - 1 ? blogs[currentIndex + 1] : null;

  return (
    <div className={styles.blogNavigator}>
      {/* Previous Button */}
      {prevBlog ? (
        <Link
          to={`/blog/${category}/${prevBlog.id}`}
          className={`${styles.navBtn} ${styles.prev}`}
        >
          <FaArrowLeft className={styles.icon} />
          {/* <span>{prevBlog.title}</span> */}
          <span className={styles.textWrapper}>
  <span className={styles.text}>{prevBlog.title}</span>
</span>
        </Link>
      ) : (
        <span className={`${styles.navBtn} ${styles.prev} ${styles.disabled}`}>
          <FaArrowLeft className={styles.icon} />
          <span>Previous</span>
        </span>
      )}

      {/* Next Button */}
      {nextBlog ? (
        <Link
          to={`/blog/${category}/${nextBlog.id}`}
          className={`${styles.navBtn} ${styles.next}`}
        >
          {/* <span>{nextBlog.title}</span> */}
          <span className={styles.textWrapper}>
  <span className={styles.text}>{nextBlog.title}</span>
</span>
          <FaArrowRight className={styles.icon} />
        </Link>
      ) : (
        <span className={`${styles.navBtn} ${styles.next} ${styles.disabled}`}>
          <span>Next</span>
          <FaArrowRight className={styles.icon} />
        </span>
      )}
    </div>
  );
}
